export const regexConstant = {
  ALPHA_NUMERIC_SPECIAL_REGEX: /^(?=.*[A-Za-z0-9])(?=.*[!@#$%^&*])/,
  NUMBER_REGEX: /^[0-9]+$/,
  ALPHA_NUMERIC_REGEX: /^[a-zA-Z0-9]+$/,
  EMAIL_REGEX: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
  MOBILE_NUMBER: /^((\\+965-?)|0)?[0-9]{8}$/,
  KUWAIT_MOBILE_NUMBER: /^(9|6|5|4)[0-9]*$/,
};
